export default __webpack_public_path__ + "static/media/AppointmentScheduler.c2215e4d.svg";